import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TitlePage } from 'components/atoms'
import { Row, Col } from 'reactstrap'
import DisabledDates from 'domains/setting/organisms/disabled-dates'
import SettingsApiV2 from 'api/v2/admins/settings-api-v2'
import { ALERT_TYPES } from 'constants/alert-constants'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const AdminSettingPage = ({ pageUtils }) => {
  const [ disabledDates, setDisabledDates ] = useState([])

  useEffect(() => {
    handleFetchDisabledDates()
  }, [ pageUtils ])  // eslint-disable-line react-hooks/exhaustive-deps

  const handleFetchDisabledDates = () => {
    const filters = { code: 'disabled_dates' }
    SettingsApiV2.get(filters)
      .then((response) => {
        setDisabledDates(response.data.settings)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }
  /**
   * Handler to change disabled date value
   * @param {*} newValue - new value of Disabled Dates
   * @param {*} id - id of Hub that want to be updated
   */
  const handleChangeDisabledDatesValue = (newValue, id) => {
    const selectedObject      = disabledDates.find((disabledDate) => {
      return disabledDate.id == id
    })
    const selectedObjectIndex = disabledDates.findIndex((disabledDate) => {
      return disabledDate.id == id
    })
    const updatedValue        = { ...selectedObject, value: newValue }
    let newDisabledDates      = disabledDates

    newDisabledDates[ selectedObjectIndex ] = updatedValue
    setDisabledDates([ ...newDisabledDates ])
  }

  const handleUpdate = (setting) => {
    SettingsApiV2.update(setting.id, setting.value)
      .then(() => {
        pageUtils.setAlertMsg('Disabled Dates has already updated', ALERT_TYPES.SUCCESS)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }
  return (
    <>
      <TitlePage mainTitle='Setting' />
      <Row>
        {
          disabledDates.map((disabledDate) => (
            <Col key={ `hub-${disabledDate.id}` }>
              <DisabledDates
                disabledDate={ disabledDate }
                onUpdate={ handleUpdate }
                onChangeDisabledDates={ handleChangeDisabledDatesValue }
              />
            </Col>
          ))
        }
      </Row>
    </>
  )
}

AdminSettingPage.propTypes    = propTypes
AdminSettingPage.defaultProps = defaultProps

export default AdminSettingPage
